<mat-card class="mb-2" *ngIf="data">
    <mat-card-content>
      <h3 class="info-title">{{data.title}}</h3>
  
      <mat-accordion>
        <mat-expansion-panel *ngFor="let item of data.items">
          <mat-expansion-panel-header>
            <mat-panel-title>
                {{item.question}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{item.answer}}</p>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>